var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReview = function SvgReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M26.667 1H3.333A2.34 2.34 0 0 0 1 3.333v17.093a2.34 2.34 0 0 0 2.333 2.333h7.934l2.69 5.38c.573 1.148 1.512 1.148 2.086 0l2.69-5.38h7.934A2.34 2.34 0 0 0 29 20.426V3.333A2.34 2.34 0 0 0 26.667 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m19.56 9.81-2.437-.355-1.09-2.209c-.569-1.15-1.498-1.15-2.066 0l-1.09 2.209-2.438.354c-1.27.185-1.557 1.069-.638 1.964l1.764 1.72-.417 2.428c-.216 1.265.535 1.81 1.671 1.213L15 15.988l2.18 1.146c1.137.598 1.889.052 1.672-1.213l-.417-2.428 1.764-1.72c.92-.895.632-1.78-.638-1.964"
  })));
};
export default SvgReview;